'use client'

import SearchNav from './header-search-nav'
import { useAutocomplete } from './use-autocomplete'

const SearchNavApp = ({ triggerInputFocus }: { triggerInputFocus?: boolean }) => {
  return <SearchNav triggerInputFocus={triggerInputFocus} useAutocomplete={useAutocomplete} />
}

export default SearchNavApp
